import {
  selectBlockchainsLoadingStatus,
  selectPublicBlockchains,
} from 'modules/chains/store/selectors';
import { useAppSelector } from 'store/useAppSelector';

export const usePublicChainsInfo = () => {
  const chains = useAppSelector(selectPublicBlockchains);
  const isLoading = useAppSelector(selectBlockchainsLoadingStatus);

  return { chains, isLoading };
};
